import { Component } from '@angular/core';

import { FoundingCircle } from './founding-circle/founding-circle';
import { OurOrigin } from './our-origin/our-origin';
import { OurTeam } from './our-team/our-team';
import { WeBelieve } from './we-believe/we-believe';

@Component({
  selector: 'app-origin',
  imports: [WeBelieve, OurOrigin, OurTeam, FoundingCircle],
  templateUrl: './origin.html',
})
export class Origin {}
